import type { CSSProperties } from 'react';

type Props = {
  image: string;
  eyebrow: string;
  title: string;
  subtitle: string;
  position?: string;
  mobilePosition?: string;
  className?: string;
};

export function PageHero({
  image,
  eyebrow,
  title,
  subtitle,
  position = 'center',
  mobilePosition,
  className = '',
}: Props) {
  const style = {
    '--page-hero-image': `url(${image})`,
    '--page-hero-position': position,
    '--page-hero-position-mobile': mobilePosition ?? position,
  } as CSSProperties;

  return (
    <section className={`page-hero${className ? ` ${className}` : ''}`} style={style}>
      <div className="page-hero__overlay" />
      <div className="site-container page-hero__content">
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p className="page-hero__subtitle">{subtitle}</p>
      </div>
    </section>
  );
}
